const Loader = () => {
  return (
    <div style={styles.wrapper}>
      <img
        src="./assets/RPJLogoWhiteBG.gif"
        alt="Loading..."
        style={styles.image}
      />
    </div>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#fff",
  },
  image: {
    width: "200px",
    height: "200px",
    objectFit: "contain",
  },
};

export default Loader;
